export default "__VITE_PUBLIC_ASSET__f548380d__"